module.exports = __webpack_public_path__ + "img/onrcpn-logo.373fcf12.svg";